import React, { ChangeEvent, FC, memo } from "react";

import SearchModal from "@/components/molecules/modals/SearchModal";
import { ServicesSearchField } from "@/components/organisms/services/ServicesSearchField";
import { ServiceSearchConditions } from "@/models/service/service";
import { IndexService } from "@/apis/clients";
import { ServiceList } from "./ServiceList";

interface Props {
  isOpen: boolean;
  close: () => void;
  newParams: ServiceSearchConditions;
  setNewParams: (c: ServiceSearchConditions) => void;
  handleOnChange: (
    ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  handleClear: () => void;
  handleSearch: () => Promise<void>;
  serviceList: IndexService[];
  handlePublishPage?: (serviceId: number, id?: number, bool?: boolean) => void;
  handleDuplicateService: (id: number, status: number) => void;
  handleClickDelete: (service: IndexService) => void | Promise<void>;
}

const ServiceSearchModalBase: FC<Props> = ({
  isOpen,
  close,
  newParams,
  setNewParams,
  handleOnChange,
  handleClear,
  handleSearch,
  serviceList,
  handleClickDelete,
  handleDuplicateService,
  handlePublishPage, 
}) => {
  return (
    <SearchModal
      title="詳細検索"
      isOpen={isOpen}
      handleClose={close}
      handleClear={handleClear}
      handleSearch={handleSearch}
    >
      <ServicesSearchField
        handleOnChange={handleOnChange}
        handleClear={handleClear}
        handleSearch={handleSearch}
        serviceSearchConditions={newParams}
        setServiceSearchConditions={setNewParams}
      />
      <div className="px-4 pb-4 overflow-y-auto">
        <ServiceList
          services={serviceList}
          handleDuplicateService={(id, status) => void handleDuplicateService(id, status)}
          handlePublishPage={(serviceId, id, status) => handlePublishPage && void handlePublishPage(serviceId, id, status)}
          handleClickDelete={handleClickDelete}
        />
      </div>
    </SearchModal>
  );
};

export const ServiceSearchModal = memo(ServiceSearchModalBase);
